import "whatwg-fetch";

class ServiceApi {
  static handleErrors(response) {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response;
  }

  static buildRequest(user, endpoint, sendCustomerId = true) {
    const customerId = sendCustomerId
      ? `/${user.profile["https://www.cygate.se/soc/customer_name"]}`
      : "";
    const uri = `${global.ApiUrl}/${endpoint}${customerId}`;

    return new Request(uri, {
      headers: { Authorization: `Bearer ${user.access_token}` }
    });
  }

  static getSecurityAlertsForLastMonth(user) {
    return fetch(ServiceApi.buildRequest(user, "securityalertslastmonth"))
      .then(ServiceApi.handleErrors)
      .then(response => response.json());
  }

  static getSecurityAlertsLastWeek(user) {
    return fetch(ServiceApi.buildRequest(user, "securityalertslastweek"))
      .then(ServiceApi.handleErrors)
      .then(response => response.json());
  }

  static getIncidentsOverview(user) {
    return fetch(ServiceApi.buildRequest(user, "incidents/overview"))
      .then(ServiceApi.handleErrors)
      .then(response => response.json());
  }

  static getOpenIncidents(user) {
    return fetch(ServiceApi.buildRequest(user, "incidents/Open"))
      .then(ServiceApi.handleErrors)
      .then(response => response.json());
  }

  static getCloseIncidents(user) {
    return fetch(ServiceApi.buildRequest(user, "incidents/Closed"))
      .then(ServiceApi.handleErrors)
      .then(response => response.json());
  }

  static getLogSources(user) {
    return fetch(ServiceApi.buildRequest(user, "devices"))
      .then(ServiceApi.handleErrors)
      .then(response => response.json());
  }

  static getDeviceGroups(user) {
    return fetch(ServiceApi.buildRequest(user, "devicegroups"))
      .then(ServiceApi.handleErrors)
      .then(response => response.json());
  }

  static getLogsPerDay(user) {
    return fetch(ServiceApi.buildRequest(user, "logsizeperday"))
      .then(ServiceApi.handleErrors)
      .then(response => response.json());
  }

  static getSystemStatus(user) {
    return fetch(ServiceApi.buildRequest(user, "systemstatus"))
      .then(ServiceApi.handleErrors)
      .then(response => response.json());
  }

  static getCustomerInformation(user) {
    return fetch(ServiceApi.buildRequest(user, "customerinformation"))
      .then(ServiceApi.handleErrors)
      .then(response => response.json());
  }

  static getReports(user) {
    return fetch(ServiceApi.buildRequest(user, "reports", false))
      .then(ServiceApi.handleErrors)
      .then(response => response.json());
  }

  static downloadReport(user, reportId) {
    return fetch(
      ServiceApi.buildRequest(
        user,
        `downloadreport?reportId=${reportId}`,
        false
      )
    )
      .then(ServiceApi.handleErrors)
      .then(response => response.blob());
  }


  static putResolutionProposal(user, incidentId, commentId, commentType) {
    const customerId = `${user.profile["https://www.cygate.se/soc/customer_name"]}`;
    const uri = `${global.ApiUrl}/incidents/resolutionproposalaction`;

    let request = new Request(uri, {
        method: "PUT",
        headers: {
            Authorization: `Bearer ${user.access_token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ "incidentId": incidentId, "parentCommentId": commentId, "actionType": commentType, "customerId": customerId })
    });

    return fetch(request)
        .then(ServiceApi.handleErrors);
  }

  static postComment(user, incidentId, comment, commentType) {
    const customerId = `${user.profile["https://www.cygate.se/soc/customer_name"]}`;
    const uri = `${global.ApiUrl}/Incidents/Comments`;

    let request = new Request(uri, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${user.access_token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ "incidentId": incidentId, "comment": comment, "customerId": customerId, "commentType": commentType })
    });

    return fetch(request)
        .then(ServiceApi.handleErrors);
  }
}

export default ServiceApi;



// WEBPACK FOOTER //
// ./src/api/ServiceApi.js